export default "__VITE_ASSET__BGXNi2H4__"